require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es6.array.species.js
// module id = Adki
// module chunks = 1